import { useState, useEffect } from 'react';

import type { ShowcaseProject } from 'data/v3/showcases';

export const useSuggestedTitle = ({
  types,
  materials,
}: {
  types: ShowcaseProject['projectTypes'];
  materials: ShowcaseProject['materialsUsed'];
}) => {
  const [titleSuggestion, setTitleSuggestion] = useState<string>();

  useEffect(() => {
    const typeValue = types.length && types[0];
    const materialValue = materials.length && materials[0];

    if (typeValue && materialValue) {
      setTitleSuggestion(`${typeValue} using ${materialValue}`);
    }
  }, [types, materials, setTitleSuggestion]);

  return titleSuggestion;
};
